import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";

import { useLocation } from "react-router-dom";
// import Invoice from "../Sales/Invoice";
// import SalesRecord from "../SalesRecord";
// import SalesVoucher from "../SalesVoucher";
import ProductReplace from "../ProductReplace";
import ProductReplaceRecord from "../ProductReplaceRecord";

import { accessChecker } from "../../lib/functions"; 

const SalesRepleceTabs = ({authInfo}) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const menuData = [
    {
      label: "Product Replace",
      key: "entry",
      value: "product_replace",
      children: (
        <>
          <ProductReplace  authInfo={authInfo}/>
        </>
      ),
    },
    {
      label: "Product Replace Record",
      key: "record",
      value: "product_replace_record",
      children: (
        <>
          <ProductReplaceRecord />
        </>
      ),
    },
 
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));
  return (
    <Tabs
      defaultActiveKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default SalesRepleceTabs;
